import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-ep-card',
  templateUrl: './ep-card.component.html',
  styleUrls: ['./ep-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EpCardComponent {
  @Input() highlighted = false;
  @Input() rowSpan = 1;

  @HostBinding('class.ep-card--highlighted')
  get isHighlighted(): boolean {
    return this.highlighted;
  }

  @HostBinding('style.grid-row')
  get gridRow(): string {
    return `span ${this.rowSpan}`;
  }
}
